import { bus, helper } from '@/utils'

export default {
  beforeDestroy () {
    bus.$off('show-add-firmware')
  },
  computed: {
    getFileName () {
      return this.selectedFileName || this.$t('NoFileChosen')
    }
  },
  methods: {
    appendFormData () {
      const formData = new FormData()
      const { name, list, fileName } = this.uploadedFirmware

      formData.append('inputVersion', this.data.version)
      formData.append('inputLastVersion', this.data.lastVersion)
      formData.append('inputSHA1', this.data.sha1)
      formData.append('inputModel', this.data.model)
      formData.append(name, list, fileName)
      if (this.data.trigger) {
        formData.append('trigger', 'trigger')
      }

      return formData
    },
    closePopup () {
      this.reset()
      this.showModal = false
    },
    filesChange (fieldName, fileList) {
      const fileExist = !!(fileList && fileList[0])
      this.selectedFileName = (fileExist && fileList[0].name) ? fileList[0].name : ''

      if (fileExist) {
        this.uploadedFirmware = {
          name: fieldName,
          list: fileList[0],
          fileName: fileList[0].name
        }
      }
    },
    reset () {
      this.data = {
        formData: null,
        imgFile: null,
        lastVersion: null,
        model: null,
        trigger: null,
        sha1: null,
        version: null
      }
      this.loading = false
      this.selectedFileName = ''
      this.uploadedFirmware = {}
      document.getElementById(this.uploadFieldName).value = ''
      this.$nextTick(() => {
        this.$validator.reset()
        this.$validator.errors.clear()
      })
    },
    uploadFirmware () {
      return this.$validator.validateAll()
        .then(async (result) => {
          if (result) {
            this.loading = true

            try {
              this.data.formData = this.appendFormData()
              const upload = await this.$api.addFirmware(this.data.formData)
              if (upload.status !== 200) {
                return
              }
              this.$message({
                message: this.$t('messageFirmwareUpload'),
                showClose: true,
                type: 'success'
              })
            } catch (error) {
              helper.showErrorMessage(this, this.component, error)
            }

            bus.$emit('get-firmware-list')
            this.closePopup()
          }
        })
    }
  },
  name: 'FirmwareUpload',
  data () {
    return {
      component: 'firmwareUpload',
      data: {
        formData: null,
        imgFile: null,
        lastVersion: null,
        model: null,
        trigger: null,
        sha1: null,
        version: null
      },
      dialogProps: {
        beforeClose: () => this.closePopup()
      },
      labelWidth: '150px',
      loading: false,
      selectedFileName: '',
      showModal: false,
      uploadedFirmware: {},
      uploadFieldName: 'firmwareFile',
      validate: {
        semver: /[0-9]+\.[0-9]+\.[0-9]+/,
        sha1: /^([0-9a-f]){40}$/
      }
    }
  },
  mounted () {
    bus.$on('show-add-firmware', (show) => {
      if (show) {
        this.showModal = true
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/FirmwareUpload/FirmwareUpload.js